import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ffee7a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "yt-slide__toolbar" }
const _hoisted_2 = ["aria-label", "title"]
const _hoisted_3 = {
  class: "yt-slide__stats",
  "aria-label": "Profile stats"
}
const _hoisted_4 = { class: "yt-slide__stats-head" }
const _hoisted_5 = { class: "yt-slide__stats-avatar" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "yt-slide__stats-name" }
const _hoisted_9 = { class: "yt-slide__stats-row" }
const _hoisted_10 = { class: "yt-slide__stats-label" }
const _hoisted_11 = { class: "yt-slide__stats-points" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-coins",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = { class: "yt-slide__stats-grid" }
const _hoisted_14 = { class: "yt-slide__stat" }
const _hoisted_15 = { class: "yt-slide__stat-label" }
const _hoisted_16 = { class: "yt-slide__stat-value" }
const _hoisted_17 = { class: "yt-slide__stat" }
const _hoisted_18 = { class: "yt-slide__stat-label" }
const _hoisted_19 = { class: "yt-slide__stat-value yt-slide__stat-value--gold" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-star",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_21 = { class: "yt-slide__xp" }
const _hoisted_22 = { class: "yt-slide__xp-head" }
const _hoisted_23 = { class: "yt-slide__stat-label" }
const _hoisted_24 = {
  type: "button",
  class: "yt-slide__xp-link"
}
const _hoisted_25 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_26 = { class: "yt-slide__xp-text" }
const _hoisted_27 = { class: "yt-slide__nav" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "yt-slide__children"
}
const _hoisted_30 = { class: "yt-slide__label" }
const _hoisted_31 = { class: "yt-slide__footer" }

import { ref, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { apiRedis } from '@/api/index'
import { CUSTOMER_MENU_INFO } from '@/const/ApiRedis'
import commons from '@/utils/Common'
import {
  buildMenuTree,
  parseMenuPayload,
  type CustomerMenuItem,
} from '@/utils/customerMenu'
import { CONTACT, HOME, INFORM } from '@/const/path'

type ProfileMenuItem = CustomerMenuItem


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideProfile',
  emits: ["collapsed-change"],
  setup(__props, { emit: __emit }) {

const { t, te } = useI18n()

const emit = __emit

const route = useRoute()
const blogsType = ref<ProfileMenuItem[]>([])
const isLogin = ref(false)
const userTagName = ref('')
const user = ref<Record<string, any>>({})
const collapsed = ref(true)
const expandedMap = ref<Record<number | string, boolean>>({})
const hasNotification = ref(true)

const avatarInitial = computed(() => {
  const name = (displayName.value || 'H').trim()
  return name.charAt(0).toUpperCase() || 'H'
})

const displayName = computed(
  () =>
    user.value.name ||
    user.value.fullName ||
    userTagName.value ||
    t('profile.account'),
)

const channelHandle = computed(() => {
  const raw =
    user.value.tagName ||
    user.value.tag ||
    user.value.phone ||
    user.value.mobile ||
    userTagName.value
  if (!raw) return '@—'
  return `@${String(raw).trim().replace(/^@/, '')}`
})

const userAvatar = computed(() => user.value.avatar || user.value.image || '')

const totalPoints = computed(() => Number(user.value.points ?? user.value.totalPoint ?? 241301.89))
const userLevel = computed(() => Number(user.value.level ?? 73))
const userRankLabel = computed(() => user.value.rankLabel || user.value.rank || t('profile.rankGold'))
const xpCurrent = computed(() => Number(user.value.xp ?? user.value.experience ?? 616576))
const xpMax = computed(() => Number(user.value.xpMax ?? user.value.experienceMax ?? 1640000))
const xpPercent = computed(() =>
  xpMax.value > 0 ? Math.min(100, Math.round((xpCurrent.value / xpMax.value) * 100)) : 0,
)

const formattedPoints = computed(() =>
  totalPoints.value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }),
)

const visibleMenus = computed(() =>
  blogsType.value.filter((item) => {
    if (item.slug === 'auth') return isLogin.value
    return true
  })
)

const footerMenus = computed(() => [
  {
    key: 'settings',
    to: INFORM,
    icon: 'fa-solid fa-gear',
    label: t('profile.settings'),
  },
  {
    key: 'feedback',
    to: CONTACT,
    icon: 'fa-solid fa-comment-dots',
    label: t('profile.sendFeedback'),
  },
])

watch(collapsed, (value) => {
  emit('collapsed-change', value)
})

onMounted(async () => {
  isLogin.value = !!commons.checkLogin()
  user.value = commons.getUserData() || {}
  userTagName.value =
    user.value.tagName || user.value.name || user.value.fullName || user.value.username || ''
  await getBlogsType()
  emit('collapsed-change', collapsed.value)
})

const hasChildren = (item: ProfileMenuItem) =>
  Array.isArray(item?.children) && item.children.length > 0

const isExpanded = (id: number | string) => expandedMap.value[id] === true

const toggleSection = (id: number | string) => {
  expandedMap.value[id] = !isExpanded(id)
}

const toggleCollapsed = () => {
  collapsed.value = !collapsed.value
  if (collapsed.value) {
    expandedMap.value = Object.fromEntries(
      Object.keys(expandedMap.value).map((id) => [id, false])
    )
  }
}

const onParentClick = (item: ProfileMenuItem) => {
  if (collapsed.value) {
    collapsed.value = false
    expandedMap.value[item.id] = true
    return
  }
  toggleSection(item.id)
}

const isRouteActive = (slug?: string) => {
  if (!slug || slug === 'auth') return false
  const path = route.path
  return path === slug || path.startsWith(`${slug}/`)
}

const getIcon = (item: ProfileMenuItem) => item?.icon || ''

const menuLabel = (linkLabel?: string) => {
  const label = String(linkLabel || '').trim()
  if (!label) return ''
  return te(label) ? t(label) : label
}

const getBlogsType = async () => {
  try {
    const res: any = await apiRedis(CUSTOMER_MENU_INFO)
    const payload = parseMenuPayload(res)
    blogsType.value = buildMenuTree(payload)
  } catch {
    blogsType.value = []
  }

  const visible = blogsType.value.filter((item) => {
    if (item.slug === 'auth') return isLogin.value
    return true
  })

  initExpandedSections(visible)
}

const initExpandedSections = (menus: ProfileMenuItem[]) => {
  expandedMap.value = Object.fromEntries(
    menus.map((item, index) => [item.id, index === 0 && hasChildren(item)])
  )
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["yt-slide", { 'is-collapsed': collapsed.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "yt-slide__collapse-btn",
        "aria-label": collapsed.value ? _ctx.$t('profile.expandSidebar') : _ctx.$t('profile.collapseSidebar'),
        title: collapsed.value ? _ctx.$t('profile.expandSidebar') : _ctx.$t('profile.collapseSidebar'),
        onClick: toggleCollapsed
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fa-solid", collapsed.value ? 'fa-solid fa-forward-step' : 'fa-solid fa-backward-step']),
          "aria-hidden": "true"
        }, null, 2)
      ], 8, _hoisted_2)
    ]),
    _withDirectives(_createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (userAvatar.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: userAvatar.value,
                alt: displayName.value
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(avatarInitial.value), 1))
        ]),
        _createElementVNode("strong", _hoisted_8, _toDisplayString(displayName.value), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('profile.totalPoints')), 1),
        _createElementVNode("span", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(formattedPoints.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('profile.level')), 1),
          _createElementVNode("strong", _hoisted_16, _toDisplayString(userLevel.value), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('profile.rank')), 1),
          _createElementVNode("strong", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(userRankLabel.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('profile.experience')), 1),
          _createElementVNode("button", _hoisted_24, _toDisplayString(_ctx.$t('profile.xpHelp')), 1)
        ]),
        _createElementVNode("div", {
          class: "yt-slide__xp-bar",
          role: "progressbar",
          "aria-valuenow": xpCurrent.value,
          "aria-valuemin": 0,
          "aria-valuemax": xpMax.value
        }, [
          _createElementVNode("span", {
            class: "yt-slide__xp-fill",
            style: _normalizeStyle({ width: `${xpPercent.value}%` })
          }, null, 4),
          _createElementVNode("span", _hoisted_26, _toDisplayString(xpCurrent.value.toLocaleString()) + " / " + _toDisplayString(xpMax.value.toLocaleString()), 1)
        ], 8, _hoisted_25)
      ])
    ], 512), [
      [_vShow, !collapsed.value]
    ]),
    _createElementVNode("nav", _hoisted_27, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMenus.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "yt-slide__group"
        }, [
          _createVNode(_component_a_tooltip, {
            title: collapsed.value ? menuLabel(item.linkLabel) : '',
            placement: "right",
            "mouse-enter-delay": 0.2
          }, {
            default: _withCtx(() => [
              (hasChildren(item))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["yt-slide__item", { 'is-active': isExpanded(item.id) || isRouteActive(item.slug) }]),
                    onClick: ($event: any) => (onParentClick(item))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([getIcon(item), "yt-slide__icon"]),
                      "aria-hidden": "true"
                    }, null, 2),
                    _withDirectives(_createElementVNode("span", { class: "yt-slide__label" }, _toDisplayString(menuLabel(item.linkLabel)), 513), [
                      [_vShow, !collapsed.value]
                    ]),
                    _withDirectives(_createElementVNode("span", {
                      class: "yt-slide__toggle",
                      "aria-hidden": "true"
                    }, _toDisplayString(isExpanded(item.id) ? '—' : '+'), 513), [
                      [_vShow, !collapsed.value]
                    ])
                  ], 10, _hoisted_28))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: item.slug || _unref(HOME),
                    class: _normalizeClass(["yt-slide__item", { 'is-active': isRouteActive(item.slug) }])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass([getIcon(item), "yt-slide__icon"]),
                        "aria-hidden": "true"
                      }, null, 2),
                      _withDirectives(_createElementVNode("span", { class: "yt-slide__label" }, _toDisplayString(menuLabel(item.linkLabel)), 513), [
                        [_vShow, !collapsed.value]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
            ]),
            _: 2
          }, 1032, ["title"]),
          (!collapsed.value && hasChildren(item) && isExpanded(item.id))
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: child.id,
                    to: child.slug || _unref(HOME),
                    class: _normalizeClass(["yt-slide__item yt-slide__item--child", { 'is-active': isRouteActive(child.slug) }])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass([getIcon(child), "yt-slide__icon"]),
                        "aria-hidden": "true"
                      }, null, 2),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(menuLabel(child.linkLabel)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_31, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerMenus.value, (item) => {
        return (_openBlock(), _createBlock(_component_a_tooltip, {
          key: item.key,
          title: collapsed.value ? item.label : '',
          placement: "right",
          "mouse-enter-delay": 0.2
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: item.to,
              class: _normalizeClass(["yt-slide__item", { 'is-active': isRouteActive(item.to) }])
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass([item.icon, "yt-slide__icon"]),
                  "aria-hidden": "true"
                }, null, 2),
                _withDirectives(_createElementVNode("span", { class: "yt-slide__label" }, _toDisplayString(item.label), 513), [
                  [_vShow, !collapsed.value]
                ])
              ]),
              _: 2
            }, 1032, ["to", "class"])
          ]),
          _: 2
        }, 1032, ["title"]))
      }), 128))
    ])
  ], 2))
}
}

})